import { ICurriculaInfo } from '../TreeActions'
import { CurriculumTreeResource } from '../../../providers/resources'
import { doAdminQueries, IQueryInfo } from '../../../providers/mutations'

export async function getAllCurriculaInfo(
  treeIdVersions: string[],
  includeMasterId: boolean,
): Promise<{ [treeId: string]: ICurriculaInfo[] }> {
  const aliasMap: { [key: string]: string } = {}
  const queries = treeIdVersions.map((idVersion, i) => {
    const [treeId, version] = idVersion.split(':')
    const alias = `tree_${i}`
    aliasMap[alias] = idVersion
    return {
      ...curriculaInfoQueryForVersion(treeId, version, includeMasterId),
      alias,
    }
  })
  const resp = await doAdminQueries<ICurriculaInfo[]>(queries)
  return Object.keys(resp.data ?? {}).reduce<Record<string, ICurriculaInfo[]>>(
    (acc, alias_1) => {
      acc[aliasMap[alias_1]] = resp.data?.[alias_1]
      return acc
    },
    {},
  )
}

function curriculaInfoQueryForVersion(
  treeId: string,
  version: string,
  includeMasterId: boolean,
) {
  const queryData = {
    resourceData: { ...CurriculumTreeResource },
    params: { tree_id: treeId, version },
  }
  if (includeMasterId) {
    queryData.resourceData.fields?.push('master_version')
  }
  return queryData
}

export function updateTreeVersions(idVersion: string[]) {
  const key = 'updateTreeVersions'
  const query: IQueryInfo = {
    resourceData: {
      key,
      fields: ['total_affected'],
    },
    params: {
      tree_ids: idVersion,
    },
  }
  return doAdminQueries<{ total_affected: number }>([query]).then((resp) => {
    return { totalAffected: resp.data?.[key].total_affected }
  })
}
